import { useState } from 'react';

// Import all help section components
import IntroSection from './help-sections/IntroSection';
import LoginSection from './help-sections/LoginSection';
import DashboardSection from './help-sections/DashboardSection';
import ClassesSection from './help-sections/ClassesSection';
import FeesSection from './help-sections/FeesSection';
import AISection from './help-sections/AISection';
import QuizzesSection from './help-sections/QuizzesSection';
import CalendarSection from './help-sections/CalendarSection';
import BlogsSection from './help-sections/BlogsSection';
import SupportSection from './help-sections/SupportSection';
import ProfileSection from './help-sections/ProfileSection';
import AdminSection from './help-sections/AdminSection';
import TipsSection from './help-sections/TipsSection';
import FAQSection from './help-sections/FAQSection';

const HelpPage = () => {
    const [activeSection, setActiveSection] = useState('intro');

    const sections = [
        { id: 'intro', title: '🎯 Giới thiệu', icon: '📚' },
        { id: 'login', title: 'Đăng nhập', icon: '🔐' },
        { id: 'dashboard', title: 'Trang chủ', icon: '📊' },
        { id: 'classes', title: 'Lớp học', icon: '📚' },
        { id: 'fees', title: 'Học phí', icon: '💰' },
        { id: 'ai', title: 'Trợ lý AI', icon: '🤖' },
        { id: 'quizzes', title: 'Bài kiểm tra', icon: '📝' },
        { id: 'calendar', title: 'Lịch học', icon: '📅' },
        { id: 'blogs', title: 'Bài học lý thuyết', icon: '📖' },
        { id: 'feedback', title: 'Hỗ trợ', icon: '💬' },
        { id: 'profile', title: 'Hồ sơ', icon: '👤' },
        { id: 'tips', title: 'Mẹo hay', icon: '💡' },
        { id: 'faq', title: 'Câu hỏi', icon: '❓' },
    ];

    const renderContent = () => {
        switch (activeSection) {
            case 'intro':
                return <IntroSection />;
            case 'login':
                return <LoginSection />;
            case 'dashboard':
                return <DashboardSection />;
            case 'classes':
                return <ClassesSection />;
            case 'fees':
                return <FeesSection />;
            case 'ai':
                return <AISection />;
            case 'quizzes':
                return <QuizzesSection />;
            case 'calendar':
                return <CalendarSection />;
            case 'blogs':
                return <BlogsSection />;
            case 'feedback':
                return <SupportSection />;
            case 'profile':
                return <ProfileSection />;
            case 'admin':
                return <AdminSection />;
            case 'tips':
                return <TipsSection />;
            case 'faq':
                return <FAQSection />;
            default:
                return <IntroSection />;
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 py-8 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                    {/* Sidebar Navigation */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-24">
                            <h2 className="text-xl font-bold text-slate-900 mb-4">📑 Mục lục</h2>
                            <nav className="space-y-2">
                                {sections.map((section) => (
                                    <button
                                        key={section.id}
                                        onClick={() => setActiveSection(section.id)}
                                        className={`w-full text-left px-4 py-3 rounded-lg transition-all ${
                                            activeSection === section.id
                                                ? 'bg-indigo-600 text-white shadow-lg'
                                                : 'bg-slate-50 text-slate-700 hover:bg-slate-100'
                                        }`}
                                    >
                                        <span className="mr-2">{section.icon}</span>
                                        {section.title}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="lg:col-span-3">
                        <div className="bg-white rounded-2xl shadow-lg p-8">
                            {renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpPage;
